import { jsx, jsxs } from 'react/jsx-runtime';
import { useState, useEffect } from 'react';
import { getStyle } from './utils.es.js';
import { MAPPING_ALIGNMENT_FLEX } from './constants.es.js';
import { c as calculateTimeDelta, a as addPaddingNumber } from './common-dbaafe9f.js';
import 'tslib';
import '@teko-builder/types/pb';
import dayjs from 'dayjs';
import styled from '@emotion/styled';

const Countdown = ({ countdownType: _countdownType = 'due', due, showDays = true, showHours = true, showMinutes = true, showSeconds = true, showLabel = false, labelDays, labelHours, labelMinutes, labelSeconds, countdownStyle, commonStyle, }) => {
    const { elementGap, labelGap, digitStyle, labelStyle, timeUnitStyle, layout, labelPosition, align, } = countdownStyle || {};
    const dueDate = dayjs(due, 'DD/MM/YYYY HH:mm').toDate();
    const [duration, setDuration] = useState(calculateTimeDelta(new Date(), dueDate));
    useEffect(() => {
        const intervalId = setInterval(() => {
            setDuration(calculateTimeDelta(new Date(), dueDate));
        }, 1000);
        return () => {
            clearInterval(intervalId);
        };
    }, [due]);
    return (jsx(Wrapper, Object.assign({ align: align }, { children: jsxs(TimeWrapper, Object.assign({ commonStyle: Object.assign(Object.assign({}, commonStyle), { gap: elementGap }) }, { children: [showDays && (jsxs(TimeUnit, Object.assign({ layout: layout, labelPosition: labelPosition, labelGap: labelGap, timeUnitStyle: timeUnitStyle }, { children: [jsx(Digit, Object.assign({ digitStyle: digitStyle }, { children: addPaddingNumber(duration.days) })), showLabel && jsx(Label, Object.assign({ labelStyle: labelStyle }, { children: labelDays }))] }))), showHours && (jsxs(TimeUnit, Object.assign({ layout: layout, labelPosition: labelPosition, labelGap: labelGap, timeUnitStyle: timeUnitStyle }, { children: [jsx(Digit, Object.assign({ digitStyle: digitStyle }, { children: addPaddingNumber(duration.hours) })), showLabel && jsx(Label, Object.assign({ labelStyle: labelStyle }, { children: labelHours }))] }))), showMinutes && (jsxs(TimeUnit, Object.assign({ layout: layout, labelPosition: labelPosition, labelGap: labelGap, timeUnitStyle: timeUnitStyle }, { children: [jsx(Digit, Object.assign({ digitStyle: digitStyle }, { children: addPaddingNumber(duration.minutes) })), showLabel && jsx(Label, Object.assign({ labelStyle: labelStyle }, { children: labelMinutes }))] }))), showSeconds && (jsxs(TimeUnit, Object.assign({ layout: layout, labelPosition: labelPosition, labelGap: labelGap, timeUnitStyle: timeUnitStyle }, { children: [jsx(Digit, Object.assign({ digitStyle: digitStyle }, { children: addPaddingNumber(duration.seconds) })), showLabel && jsx(Label, Object.assign({ labelStyle: labelStyle }, { children: labelSeconds }))] })))] })) })));
};
const Wrapper = styled.div(({ align }) => `
  display: flex;
  justify-content: ${MAPPING_ALIGNMENT_FLEX[align]};
`);
const TimeWrapper = styled.div(({ commonStyle }) => `
  ${getStyle(commonStyle)};
  display: flex;
`);
const Digit = styled.div(({ digitStyle }) => `
  ${getStyle(digitStyle)};
`);
const Label = styled.div(({ labelStyle }) => `
  ${getStyle(labelStyle)}
`);
const TimeUnit = styled.div(({ layout, labelPosition, labelGap, timeUnitStyle }) => `
  ${getStyle(timeUnitStyle)}
  display: flex;
  ${labelGap ? `gap: ${labelGap}px;` : ''}
  ${layout === 'horizontal'
    ? `align-items: ${labelPosition};`
    : `flex-direction: column;`};
`);
Countdown.displayName = 'Countdown';

export { Countdown as C };
